import { QRInput } from 'src/app/models/qr-input.model';
import { QRToggle } from 'src/app/models/qr-toggle.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Compensation } from '@base/src/app/pages/configuration/panel/configuration.component';

@Component({
  selector: 'app-config-add-edit-compensation',
  templateUrl: './config-add-edit-compensation.component.html',
  styleUrls: ['./config-add-edit-compensation.component.scss'],
})
export class ConfigAddEditCompensationComponent implements OnInit {
  @Input() value!: { compensation: Compensation | null; isEdit: boolean };
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  isEdit = false;

  input: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
  };

  inputNumber: QRInput = {
    mode: QRInput.MODE_DECIMAL,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 500,
  };

  mainToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Facturación bruta', 'Resultado bruto'],
    optionSelected: 0,
  };

  errors: any = {
    name: true,
    number: false,
  };

  compensation: any = {
    name: '',
    type: 1,
    billingPercentage: 0,
    grossPercentage: 0,
  };

  ngOnInit(): void {
    if (this.value?.isEdit) {
      this.isEdit = this.value.isEdit;
      this.compensation = this.value.compensation;
      this.errors.name = false;
      this.mainToggle.optionSelected = this.compensation.type - 1;
    }
    this.checkForm();
  }

  changeName($event: any) {
    this.errors.name = true;
    if ($event) {
      this.compensation.name = $event;
      const regex = /^[a-zA-Z\s]*$/;
      this.errors.name = !regex.test($event);
    }
    this.checkForm();
  }

  onChangeToggle($event: any) {
    this.compensation.type = ($event ?? 0) + 1;
    this.checkForm();
  }

  checkForm() {
    let result = true;
    Object.keys(this.errors).forEach((key: any) => {
      result = result && !this.errors[key];
    });
    this.change.emit('disabled');
    if (result) {
      if (this.compensation.type == 1) this.compensation.grossPercentage = 0;
      if (this.compensation.type == 2) this.compensation.billingPercentage = 0;
      const dto = {
        compensation: this.compensation,
        action: this.isEdit ? 'edit' : 'create',
      };
      this.change.emit(dto);
    }
  }

  changeNumber($event: any) {
    this.errors.number = true;
    if ($event && Number($event > 0) && Number($event <= 100)) {
      this.compensation.billingPercentage = $event;
      this.compensation.grossPercentage = $event;
      this.compensation = { ...this.compensation };
      this.errors.number = false;
    }
    this.checkForm();
  }

  isValidDecimalNumber(e: KeyboardEvent): any {
    // Excepciones
    if (
      (e.key === 'a' && e.ctrlKey === true) || // Permitir: Ctrl+A
      (e.key === 'c' && e.ctrlKey === true) || // Permitir: Ctrl+C
      (e.key === 'v' && e.ctrlKey === true) || // Permitir: Ctrl+V
      (e.key === 'x' && e.ctrlKey === true) || // Permitir: Ctrl+X
      (e.key === 'a' && e.metaKey === true) || // Permitir+A (Mac)
      (e.key === 'c' && e.metaKey === true) || // Permitir: Cmd+C (Mac)
      (e.key === 'v' && e.metaKey === true) || // Permitir: Cmd+V (Mac)
      (e.key === 'x' && e.metaKey === true) || // Permitir: Cmd+X (Mac)
      e.key === 'Tab' || // Permitir: Tab
      e.key === 'Backspace' || // Permitir: Backspace
      e.key === 'Delete' || // Permitir: Delete
      e.key === 'ArrowLeft' || // Permitir: Flecha a la izquierda
      e.key === 'ArrowRight' || // Permitir: Flecha a la derecha
      e.key === ',' // Permitir: Comma
    ) {
      return; // dejar que pase, no hago nada
    }

    // Asegurarse que es un número valido
    if (e.key === ' ' || isNaN(Number(e.key))) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  }
}
